<template>
	<div :class="classList">
		<slot></slot>
	</div>
</template>

<script type="text/babel">
export default {
	props: {
		extraClasses: { default: "" },
		type: { default: "primary" }, // primary, secondary, success, danger, warning, info
	},

	computed: {
		classList() {
			let classList = "alert";

			classList += " " + this.type;

			if (this.extraClasses !== "") {
				classList += " " + this.extraClasses;
			}

			return classList;
		},
	},
};
</script>
